import Link from './LocalizedLink';
import React, { FC } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { ImageDataLike, getImage } from 'gatsby-plugin-image';

type LogoProps = {
  showLogoSchema?: boolean;
};

const Logo: FC<LogoProps> = ({ showLogoSchema }) => {
  const data = useStaticQuery<Queries.HeaderSectionQuery>(graphql`
    query HeaderSection {
      logoImage: file(name: { eq: "logo" }) {
        publicURL
        childImageSharp {
          gatsbyImageData(width: 120, placeholder: BLURRED, sizes: "(max-width: 600px) 50px, 500px", formats: [AUTO])
        }
      }
    }
  `);

  const imgSrc = data.logoImage && getImage(data.logoImage as ImageDataLike);

  if (!imgSrc) return null;

  return (
    <Link to="/" style={{ fontSize: 'clamp(24px, 5vw, 30px)', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
      Amanita Store
    </Link>
  );
};

export default Logo;
